import { useQuery } from '@tanstack/react-query';
import { ordersApi } from '@/lib/api/services/orders.api';
import type { ListOrdersParams } from '@/lib/api/services/orders.api';
import { orderKeys } from './keys';

const POLL_INTERVAL = 8_000; // refresh board every 8 s

interface QueryOptions {
  enabled?: boolean;
}

export function useOrders(params?: ListOrdersParams, options?: QueryOptions) {
  return useQuery({
    queryKey: orderKeys.list(params),
    queryFn: () => ordersApi.list(params),
    enabled: options?.enabled ?? true,
    refetchInterval: POLL_INTERVAL,
  });
}
